
// Finding the CSS Selctor using the HTML Element
const popup = document.querySelector("#email-popup");
const closeButton = document.querySelector("#CLOSE");
const form = document.querySelector("#email-form");
const emailInput = document.querySelector("#email-input");
const formMessage = document.querySelector("#formessage");
const landingpage = document.querySelector("#email-box");
const submitButton = document.querySelector("#Submit");
const cornerSignupButton = document.querySelector("#corner-signup");

// Delay the pop up.
setTimeout(function(){
popup.classList.add("show")
},2000);

//Give the popup a function
function closePopup() {
popup.classList.remove("show");
}

// Give the close feature the correct function.
closeButton.addEventListener("click", closePopup);

// Open the popup when the glowing corner button is clicked.
function openPopup() {
popup.classList.remove("fade-out");
popup.style.display = "";
popup.classList.add("show");
}

cornerSignupButton.addEventListener("click", openPopup);

// To move away the pop up when the user clicks on the submit button.
function SignUp() {
popup.classList.remove("show");
}

// Delay in Cursor Glow
const glow = document.querySelector("#cursor");
let mouseX = 0;
let mouseY = 0;
let currentX = 0;
let currentY = 0;

document.addEventListener("mousemove", (e) => {
mouseX = e.clientX;
mouseY = e.clientY;
});

// Touch support for mobile
document.addEventListener("touchmove", (e) => {
if (e.touches.length > 0) {
mouseX = e.touches[0].clientX;
mouseY = e.touches[0].clientY;
}
}, { passive: true });

document.addEventListener("touchstart", (e) => {
if (e.touches.length > 0) {
mouseX = e.touches[0].clientX;
mouseY = e.touches[0].clientY;
}
});

document.addEventListener("touchend", () => {
mouseX = -100;
mouseY = -100;
});

function animate() {
currentX += (mouseX - currentX) * 0.04;
currentY += (mouseY - currentY) * 0.04;
glow.style.left = currentX + "px";
glow.style.top = currentY + "px";
requestAnimationFrame(animate);
}
animate();

// Email Subscription
form.addEventListener("submit", async function (event) {

    event.preventDefault();

formMessage.textContent = "Submitting...";

submitButton.disabled = true;



try {
const formData = new FormData(form);
const response = await fetch(form.action, {

    method:"POST",

    body: formData
});

const data = await response.json();
if (data.success) {
form.reset();
formMessage.textContent = "";

popup.classList.add("fade-out");

setTimeout(function () {
popup.style.display = "none";
}, 10000);

} else {
formMessage.textContent =
data.message || "Your email could not be saved.";

setTimeout(function () {
formMessage.textContent = "";
}, 3000);
 }

} catch (error) {
console.error(error);
formMessage.textContent =
"Something went wrong. Refresh the page and try again.";

} finally {
submitButton.disabled = false;
 }

});